import React from "react";
import { Drawer, Button } from "antd";

const DrawerPanel = ({ onClose, visible, title, placement, input, width }) => {
  
  return (
    <Drawer
      title={title}
      placement={placement}
      closable={false}
      onClose={() => onClose()}
      visible={visible}
      width={width}
    >
      {input()}
      <Button style={{ width: 150 }} type="ghost">
        Update
      </Button>
    </Drawer>
  );
};

export default DrawerPanel;
